export default {
  // Wine
  Filtro_Fasi_Vino: 'Phases',
  Filtro_Soluzioni_Vino: 'Solutions',
  Filtro_Tipologia_Vino: 'Wine Type',
  Filtro_Certificazioni_Vino: 'Certifications',
  Filtro_Tipologia_Prodotto_Vino: 'Product Type',
  // Beer
  Filtro_Stili_Birra: 'Styles',
  Filtro_Fermentazione_Birra: 'Fermentation',

  // Phases
  Fermentazione: 'Fermentation',
  'In vigna': 'In the Vineyard',
  Uva: 'Grape',
  'Mosto/Pigiatura': 'Must/Crushing',
  Affinamento: 'Aging',
  Spumantizzazione: 'Sparkling',
  Chiarifica: 'Clarification',
  Stabilizzazione: 'Stabilization',
  Finissaggio: 'Finishing',

  // Solutions
  'Aumentare la shelf life': 'Increase shelf life',
  'Per fermentazioni difficili': 'For difficult fermentations',
  'Prevenzione e cura dal bret': 'Prevention and treatment from brett',
  'Prevenzione e cura ossidazioni': 'Prevention and treatment from oxidations',
  'Prevenzione e cura riduzioni lieviti Atecnos':
    'Prevention and treatment from Atecnos yeast reductions',
  'Produzione acido malico': 'Malic acid production',
  'Proteggere il colore': 'Protecting color',
  'Arresti fermentativi': 'Fermentation stoppages',
  'Degradazione acido malico': 'Malic acid degradation',
  'Per il vigneto': 'For the vineyard',
  'Proteggere le uve in fase di raccolta': 'Protecting grapes during harvest',
  'Raggiungere la stabilità tartarica': 'Achieving tartaric stability',

  // Wine Type
  Bianchi: 'White',
  Rossi: 'Red',
  Rosati: 'Rosé',
  Spumantizzati: 'Sparkling',
  'Senza solfiti': 'Sulfite-free',
  Aromatici: 'Aromatic',
  Dolci: 'Sweet and passito',

  // Certifications
  'ICEA Prodotto Biologico': 'ICEA Organic Product',

  // Product Type
  'Lieviti Saccharomyces': 'Saccharomyces yeast',
  'Lieviti non Saccharomyces': 'Non-Saccharomyces yeast',
  'Attivanti secchi': 'Dry activators',
  'Autolisati in crema Atecnos': 'Atecnos cream autolysates',
  'Batteri lattici': 'Lactic acid bacteria',
  'Da affinamento': 'For aging',
  'In fermentazione': 'In fermentation',
  'In finissaggio': 'In finishing',
  'Per uve e mosti': 'For Grapes and musts',
  'Schizosaccharomyces pombe': 'Schizosaccharomyces pombe',
  'Super anti-ossidanti': 'Super anti-oxidants',

  // Stili Birra
  'English Barleywine': 'English Barleywine',

  'English IPA': 'English IPA',

  'Imperial Stout': 'Imperial Stout',

  'Belgian Pale Ale': 'Belgian Pale Ale',

  'English Brown Ale': 'English Brown Ale',

  'New England IPA': 'New England IPA',

  'Scottish Heavy': 'Scottish Heavy',

  Stout: 'Stout',

  Witbier: 'Witbier',

  'American IPA': 'American IPA',

  'Belgian And French Ale': 'Belgian And French Ale',

  'Belgian Blonde Ale': 'Belgian Blonde Ale',

  'Belgian Dark Strong Ale': 'Belgian Dark Strong Ale',

  'Belgian Strong Ale': 'Belgian Strong Ale',

  'Dry Stout': 'Dry Stout',

  Dubbel: 'Dubbel',

  'English Old Ale': 'English Old Ale',

  'Imperial IPA': 'Imperial IPA',

  'Oatmeal Stout': 'Oatmeal Stout',

  Saison: 'Saison',

  'Scottish Light': 'Scottish Light',

  Tripel: 'Tripel',

  'Vienna Lager': 'Vienna Lager',

  Bock: 'Bock',

  Doppelbock: 'Doppelbock',
  Marzen: 'Marzen',
  'Münchener dunkel': 'Münchener dunkel',
  Oktoberfestbier: 'Oktoberfestbier',
  'Traditional bock': 'Traditional bock',
  Weiss: 'Weiss',
  Pils: 'Pils',
  'Strong English Ale': 'Strong English Ale',
  IPA: 'IPA',
  'Juicy IPA': 'Juicy IPA',
  'Pale ale': 'Pale ale',
  Ale: 'Ale',
  'Amber Lager': 'Amber Lager',
  'American Lager': 'American Lager',
  'Dark Lager': 'Dark Lager',
  Lambic: 'Lambic',
  'Birre speciali': 'Special beers',
  'Birre speziate': 'Spiced beers',
  'Birre aromatiche': 'Aromatic beers',
  'Rifermentazioni in bottiglia': 'Bottle refermentations',
  Porter: 'Porter',
  'Fruit Beer': 'Fruit Beer',
  'American Stout': 'American Stout',
  'American Pale Ale': 'American Pale Ale',
  'American Amber Ale': 'American Amber Ale',
  'American Brown Ale': 'American Brown Ale',
  'American Ale': 'American Ale',
  'American Wheat Ale': 'American Wheat Ale',
  'Berliner Weisse': 'Berliner Weisse',
  'Bière De Garde': 'Bière De Garde',
  'Dusseldorf Altbier': 'Dusseldorf Altbier',
  'German Brown': 'German Brown',
  Kolsch: 'Kolsch',
  'Scottish Heavy': 'Scottish Heavy',
  'Traditional bock': 'Traditional bock',
  'Belgian Dubbel': 'Belgian Dubbel',

  // Fermentazione Birra
  'Alta fermentazione': 'High fermentation',
  'Bassa fermentazione': 'Low fermentation',
}
